import { render, staticRenderFns } from "./HistoryInfo.vue?vue&type=template&id=6d2f2ade&scoped=true"
import script from "./HistoryInfo.vue?vue&type=script&lang=js"
export * from "./HistoryInfo.vue?vue&type=script&lang=js"
import style0 from "./HistoryInfo.vue?vue&type=style&index=0&id=6d2f2ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2f2ade",
  null
  
)

export default component.exports